import { Button } from "@/components/ui/button";
import { Shield, Heart, Clock, Star, MessageCircle } from "lucide-react";

const WhyChooseSection = () => {
  const reasons = [
    {
      icon: Shield,
      title: "Trusted Expertise",
      description: "15+ years of dedicated practice in Vedic sciences",
    },
    {
      icon: Heart,
      title: "Personalized Care",
      description: "Every consultation tailored to your unique situation",
    },
    {
      icon: Clock,
      title: "Timely Guidance",
      description: "Quick and accurate predictions when you need them",
    },
    {
      icon: Star,
      title: "Proven Results",
      description: "15,000+ satisfied clients across Delhi NCR",
    },
  ];

  return (
    <section className="py-20 lg:py-32 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-brown-deep via-secondary to-brown-warm" />
      
      {/* Decorative Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30 0L30 60M0 30L60 30' stroke='%23D4AF37' stroke-width='0.5' fill='none'/%3E%3C/svg%3E")`,
            backgroundSize: "60px 60px",
          }}
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Why Choose <span className="text-gradient-gold">Tapask Astrologer?</span>
          </h2>
          <div className="section-divider mx-auto mb-6" />
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Experience the Power of Divine Guidance. At Tapask Astrologer, we combine 
            ancient Vedic wisdom with modern insights to provide solutions for all 
            aspects of life.
          </p>
        </div>

        {/* Reasons Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-card/50 backdrop-blur-sm border border-border/50 rounded-xl p-6 text-center card-hover"
            >
              <div className="w-14 h-14 rounded-full bg-primary/20 flex items-center justify-center mx-auto mb-4">
                <reason.icon className="w-7 h-7 text-primary" />
              </div>
              <h3 className="font-display text-lg font-semibold text-foreground mb-2">
                {reason.title}
              </h3>
              <p className="text-sm text-muted-foreground">{reason.description}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <p className="text-muted-foreground mb-6">
            Our personalized approach and proven remedies have helped countless 
            individuals find peace, prosperity, and purpose.
          </p>
          <a
            href="https://wa.me/919870511379?text=Namaste%20Pandit%20ji%2C%20I%20would%20like%20to%20book%20a%20consultation."
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              size="lg"
              className="bg-primary text-primary-foreground hover:bg-primary/90 gap-2 rounded-full px-8 py-6 text-base shadow-gold"
            >
              <MessageCircle className="w-5 h-5" />
              Book Your Consultation
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
